import './_analytics.scss'
import { useEffect } from 'react'

import { Navigate, useParams } from 'react-router-dom'

import { useHeaderLayout } from 'context/headerLayoutContext'
import { useHeaderNav } from 'context/headerNavContext'
import { usePageTitle } from 'context/pageTitleContext'
import DesktopAdditionalContent from 'features/DesktopAdditionalContent/DesktopAdditionalContent'

import { Content } from './views/Content'
import { Reports } from './views/Reports'
import { Sales } from './views/Sales'

export const Analytics = () => {
    const { id } = useParams<{ id: string }>()
    const { setHeaderNav } = useHeaderNav()
    const { setTitle } = usePageTitle()
    const { setBackgroundColor } = useHeaderLayout()

    useEffect(() => {
        setTitle('Analytics')
    }, [setTitle])

    useEffect(() => {
        setBackgroundColor('#070707')

        return () => {
            setBackgroundColor(undefined)
        }
    }, [setBackgroundColor])

    useEffect(() => {
        const navLinks = [
            '/analytics/sales',
            '/analytics/reports',
            '/analytics/content',
        ]

        setHeaderNav(navLinks)

        return () => {
            setHeaderNav([])
        }
    }, [setHeaderNav])

    const renderPage = () => {
        if (id === 'sales') {
            return <Sales />
        }

        if (id === 'reports') {
            return <Reports />
        }

        if (id === 'content') {
            return <Content />
        }

        return <Navigate to='/analytics/sales' />
    }

    return (
        <div className='parent-analytics'>
            {renderPage()}
            <DesktopAdditionalContent />
        </div>
    )
}